var React = require('react');

function CardInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M0 2C0 0.895431 0.895431 0 2 0L18 0C19.1046 0 20 0.895431 20 2V10.6504C20 11.7549 19.1046 12.6504 18 12.6504H2C0.895431 12.6504 0 11.7549 0 10.6504L0 2Z","fill":"currentColor","key":0}),React.createElement("rect",{"x":"0.0405273","y":"3.32578","width":"19.9358","height":"1.66284","fill":"#ABA49C","key":1}),React.createElement("rect",{"opacity":"0.5","x":"1.51953","y":"9.73978","width":"2.13794","height":"0.950193","rx":"0.475097","fill":"#currentColor","key":2}),React.createElement("rect",{"opacity":"0.5","x":"4.37012","y":"9.73995","width":"4.51342","height":"0.950193","rx":"0.475097","fill":"#currentColor","key":3})]);
}

CardInline.defaultProps = {"width":"20","height":"13","viewBox":"0 0 20 13","fill":"none"};

module.exports = CardInline;

CardInline.default = CardInline;
